var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.1 512.1",
    style: {
      enableBackground: "new 0 0 512.1 512.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M472.1,88.3H39.9c-22,0-39.9,17.8-39.9,39.9v255.7c0,22,17.8,39.9,39.9,39.9h432.3 c22,0,39.9-17.8,39.9-39.9V128.1C512,106.1,494.2,88.3,472.1,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.8,256h15.3l81.8-53.6V256H150v-53.6l81.8,53.6h15.3c4.9,0,8.8-4,8.8-8.8v-7l-70.2-46H256v-44.1 h-70.2l70.2-46v-7c0-4.9-4-8.8-8.8-8.8h-15.3l-81.8,53.6V88.3H106v53.6L27.3,90.3c-9.2,3-16.8,9.3-21.7,17.5l64.6,42.3H0v44.1h70.2 L0,240.2v7C0,252,4,256,8.8,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.9 141.2,158.9 141.2,88.3 114.8,88.3 114.8,158.9 0,158.9 0,185.4 114.8,185.4  114.8,256 141.2,256 141.2,185.4 256,185.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.7,103.2L80.8,150H97L15,96.8C12.8,98.7,10.6,100.9,8.7,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.3,150.1l88.4-57.4c-1.5-2.6-4.2-4.4-7.5-4.4h-1.9l-95.2,61.8H166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.5,194.2L0,251.5c1.5,2.7,5.5,4.5,8.8,4.5h1.7l95.2-61.8H89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.9,247.9l-82.7-53.7H157l93.9,60.9C253.7,253.8,255.6,251.1,255.9,247.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M328.6,192.7c-1.2,15.8-6.1,116,57.5,138.7c63.6-22.7,58.7-122.9,57.5-138.7 c-7.7,3-35.6,12.2-57.5-3.4C364.2,204.8,336.3,195.7,328.6,192.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M417.4,212.9c-3.5-2.7-9.9,2.3-17.2,1.8c-6.7-0.5-15-7.3-25.7-4.3c-3-2.7-1.5-9.1-1.5-9.1 c-7.5,4.8-8,11.4-7.5,15c-5.3,7-5,17.8-4,21c1.3,4.3,3.7,4.8,4.1,9.6c0.4,4.8,2.2,3.1,2.2,3.1c3.7-2.1,4.3-6,5.9-12.5 c6.1,0.8,10-4.7,10-4.7c-4,1.2-6.5-0.9-7.9-2.9c0.2-0.6,0.4-1.2,0.6-1.9c4.5-12.4,26.2-9,28.2-5.6c3.6,6.2,8.4,8.5,8.4,8.5 c0-6.5-4.8-12.1-4.8-12.1C415.5,217.5,417.4,212.9,417.4,212.9z M365.3,239.5c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 c0.7,0,1.3,0.6,1.3,1.3C366.6,238.9,366.1,239.5,365.3,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M396.1,292.2c4.2-1.3,3.7-9.5,8.3-15.2c4.2-5.3,14.5-8.2,18.2-18.7c3.9-0.9,8.4,3.9,8.4,3.9 c0.3-8.9-4.9-13.1-8.1-14.7c-2.8-8.4-11.8-14.2-15.1-15.2c-4.2-1.4-6.1,0.4-10.2-2s-3.8,0-3.8,0c-0.4,4.3,2.6,7,7,11.9 c-4.1,4.6-1.9,10.9-1.9,10.9c1.2-4,4.5-4.8,6.8-4.8c0.4,0.5,0.8,1,1.2,1.6c7.6,10.8-7.4,26.6-11.4,26.3c-7.2-0.5-11.8,2.1-11.8,2.1 c5.3,3.7,12.7,3,12.7,3C393.4,288,396.1,292.2,396.1,292.2z M403.7,234.3c0.4-0.6,1.2-0.7,1.8-0.3c0.6,0.4,0.7,1.2,0.3,1.8 c-0.4,0.6-1.2,0.7-1.8,0.3C403.5,235.7,403.3,234.9,403.7,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M339.2,234.8c-0.6,4.4,7.1,7.4,10.3,13.9c3,6,1.3,16.6,9.3,24.4c-0.8,3.9-7,5.9-7,5.9 c7.9,4,13.9,1.1,16.7-1.1c8.8,1,17.8-4.8,20.1-7.3c3-3.3,2.2-5.7,6.1-8.4c3.9-2.8,1.6-3.5,1.6-3.5c-3.7-2.2-7.4-0.6-13.8,1.3 c-2.4-5.6-9.1-6.3-9.1-6.3c3.1,2.8,2.5,6.1,1.5,8.2c-0.7,0.1-1.3,0.3-2,0.4c-13,2.4-21-18-19.1-21.4c3.5-6.3,3.1-11.6,3.1-11.6 c-5.6,3.3-8,10.3-8,10.3C344.1,234.1,339.2,234.8,339.2,234.8z M388.5,266.1c0.4,0.6,0.2,1.4-0.5,1.8c-0.6,0.4-1.4,0.2-1.8-0.5 c-0.4-0.6-0.2-1.4,0.5-1.8C387.4,265.3,388.2,265.5,388.5,266.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCE0C"
    },
    d: "M386.1,334.7l-0.5-0.2c-71.6-24.9-60.1-143-59.9-144.2l0.2-2.1l2,0.9c0.3,0.2,33.6,14.9,57.3-2.9 l0.9-0.7l0.9,0.7c23.8,17.8,57,3.1,57.3,2.9l2-0.9l0.2,2.1c0.1,1.2,11.7,119.3-59.9,144.2L386.1,334.7z M328.6,192.7 c-1.2,15.8-6.1,116,57.5,138.7c63.6-22.7,58.7-122.9,57.5-138.7c-7.7,3-35.6,12.2-57.5-3.4C364.2,204.8,336.3,195.7,328.6,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M346.2,295.8c8.7,15.8,21.4,29,39.9,35.6c18.5-6.6,31.2-19.8,39.9-35.6H346.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.8a73b57cb61b0ec12b973a2c199dcd3c.svg";
export { ForwardRef as ReactComponent };